import 'nprogress/nprogress.css';

import NProgress from 'nprogress';
import { MessagePlugin } from 'tdesign-vue-next';

import router from '@/router';
import { usePermissionStore } from '@/store';
import { getToken } from '@/utils/auth';

NProgress.configure({ showSpinner: false });

router.beforeEach(async (to, from, next) => {
  NProgress.start();

  const toPathArr = to.path.split('/').filter(Boolean);
  const fromPathArr = from.path.split('/').filter(Boolean);
  const toPathString = toPathArr.join('');
  const fromPathString = fromPathArr.join('');

  if (toPathArr[0] !== fromPathArr[0]) {
    sessionStorage.clear();
  }

  if (toPathString && fromPathString && toPathString.includes(fromPathString)) {
    MessagePlugin.warning('已在当前路径');
    next(false);
    NProgress.done();
    return;
  }
  if (to.path === '/login' || to.query.token) {
    next();
    NProgress.done();
    return;
  }
  const token = getToken();
  const permissionStore = usePermissionStore();
  if (token) {
    try {
      // 还没拉过权限时，先向后端请求权限 & 初始化路由
      if (!permissionStore.currentPermissionList.length) {
        await permissionStore.initBaseRoutes();
      }
      if (router.hasRoute(to.name as string)) {
        next();
      } else {
        next('/');
      }
    } catch (error: any) {
      MessagePlugin.error(error.message || '路由不存在');
      next({
        path: '/login',
        query: { redirect: encodeURIComponent(to.fullPath) },
      });
      NProgress.done();
    }
  } else {
    next({
      path: '/login',
      query: { redirect: encodeURIComponent(to.fullPath) },
    });
    NProgress.done();
  }
});

router.afterEach(async (to) => {
  const permissionStore = usePermissionStore();
  const { hasRoutePermission, currentPermissionList } = permissionStore;

  if (to.meta.permission && currentPermissionList.length && !hasRoutePermission(to.meta)) {
    console.log('路由跳转： 没有访问权限');
    MessagePlugin.error('没有访问权限');
    router.push('/result/403');
    NProgress.done();
    return;
  }
  NProgress.done();
});
